module.exports = __webpack_public_path__ + "fa8ba285f45faf236ffc41558b506232.png";